import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SEO from './SEO';
import { generateGlobalSchema } from '../utils/schemaGenerator';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <SEO schema={generateGlobalSchema()} />
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
